import {
  narrowSuggestResults,
  TASHKENT_CENTER,
  type LegacyGeoResult,
} from '../lib/geocode';

/**
 * Address SUGGESTIONS through `suggest-maps.yandex.uz/suggest-geo` — the
 * keyless endpoint the old panel's typing suggestions actually used
 * (`searchYmaps`'s non-SDK branch, which is the branch its create screen ran:
 * it never passed `ymaps3` down). It is a different product from the Geocoder:
 * rows carry a venue `tag`, a grey `subtitle` and a `distance` from the bias
 * point, which is what the old suggestion rows render.
 *
 * `center` biases results toward a point — the old screen passes the PREVIOUS
 * stop's coordinate so a bare street name resolves near the route rather than
 * across town (`ResDestination.tsx:53-63`). Without one it falls back to the
 * Tashkent centre, as `searchYmaps` did.
 *
 * Bare `fetch`, deliberately: an external Yandex service — `@noor/api`'s
 * clients would inject our gateway's auth headers and base URL.
 */
const SUGGEST_URL = 'https://suggest-maps.yandex.uz/suggest-geo';

/** The old request's fixed bias window (`spn: '0.01,0.01'`). */
const SUGGEST_SPN = '0.01,0.01';

export async function suggestAddresses(
  text: string,
  options?: { center?: [number, number]; lang?: string },
): Promise<LegacyGeoResult[]> {
  const [long, lat] = options?.center ?? TASHKENT_CENTER;
  // The old panel offered the suggest service only ru/en (`searchYmaps`:48).
  const lang = options?.lang === 'ru' ? 'ru' : 'en';

  const params = new URLSearchParams({
    part: text,
    outformat: 'json',
    v: '9',
    add_coords: '1',
    spn: SUGGEST_SPN,
    lang,
    ll: `${long}, ${lat}`,
  });

  // POST with query params — the shape the old axios call sent.
  const response = await fetch(`${SUGGEST_URL}?${params.toString()}`, {
    method: 'POST',
  });
  if (!response.ok) {
    throw new Error(`Suggest answered ${response.status}`);
  }
  return narrowSuggestResults(await response.json());
}
